/**
 * Thin wrapper over gtag/dataLayer. No-ops if GA4 is not configured,
 * so it's safe to call anywhere without conditionals.
 *
 *   import { track } from '../analytics';
 *   track('waitlist_join', { position, game });
 */

export function track(event, params = {}) {
  try {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', event, params);
  } catch {
    // swallow
  }
}

export const EVENTS = {
  WAITLIST_VIEW:    'waitlist_view',
  WAITLIST_JOIN:    'waitlist_join',
  REF_LINK_COPY:    'ref_link_copy',
  SHARE_TWITTER:    'share_twitter',
  SHARE_DISCORD:    'share_discord',
  WALLET_CONNECT:   'wallet_connect',
  TOURNAMENT_JOIN:  'tournament_join',
  TOURNAMENT_WON:   'tournament_won',
  BLOG_VIEW:        'blog_view',
  LEADERBOARD_VIEW: 'leaderboard_view',
};
